"use strict";

exports.__esModule = true;
var _App = require("./App.js");
Object.keys(_App).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _App[key]) return;
  exports[key] = _App[key];
});